<template>
  <div>Guardian Notification will come here</div>
</template>
